import {FiFileText, FiAlertCircle, FiLayers, FiPenTool, FiUser, FiSettings} from 'react-icons/fi'
import {generateOptions} from 'utils/helper'
import {STATUS_PAGE_PATH} from './path'

export const STATUS_PAGE_ROW1 = [
  {
    title: 'Incidents',
    description: 'Add or manage your incidents for the status page',
    icon: <FiFileText />,
    path: STATUS_PAGE_PATH.INCIDENTS,
  },
  {
    title: 'Maintenance',
    description: 'Add or manage your maintenance for the status page',
    icon: <FiAlertCircle />,
    path: STATUS_PAGE_PATH.MAINTENANCE,
  },
  {
    title: 'Service Components',
    description: 'Add or manage your service components for the status page',
    icon: <FiLayers />,
    path: STATUS_PAGE_PATH.SERVICE_COMPONENTS,
  },
]

export const STATUS_PAGE_ROW2 = [
  {
    title: 'Customization',
    description: 'Manage your customisation settings for the status page',
    icon: <FiPenTool />,
    path: STATUS_PAGE_PATH.CUSTOMIZATION,
  },
  {
    title: 'Manage Subscribers',
    description: 'Manage your subscribers for the status page',
    icon: <FiUser />,
    path: STATUS_PAGE_PATH.MANAGE_SUBSCRIBERS,
  },
  {
    title: 'General',
    description: 'Manage your general settings related to status page',
    icon: <FiSettings />,
    path: STATUS_PAGE_PATH.GENERAL,
  },
]

export const STATUS_PAGE_TYPES = {
  INCIDENT: 'incident',
  MAINTENANCE: 'maintenance',
}

export const MAINTAINANCE_STATUS_TYPES = {
  UPCOMING: 'upcoming',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
}

export const MAINTAINANCE_STATUS_DEFAULT_FILTER_OPTIONS = [
  {key: 'all', value: 'all', text: 'All Type'},
  ...generateOptions([
    MAINTAINANCE_STATUS_TYPES.UPCOMING,
    MAINTAINANCE_STATUS_TYPES.ONGOING,
    MAINTAINANCE_STATUS_TYPES.COMPLETED,
  ]),
]

export const TEMPLATES_TYPE_OPTIONS = generateOptions([STATUS_PAGE_TYPES.INCIDENT, STATUS_PAGE_TYPES.MAINTENANCE])

export const TEMPLATES_TYPE_DEFAULT_FILTER_OPTIONS = [
  {key: 'all', value: 'all', text: 'All Type'},
  ...TEMPLATES_TYPE_OPTIONS,
]

export const TEMPLATES_SOURCE_DEFAULT_FILTER_OPTIONS = [{key: 'all', value: 'all', text: 'All Source'}]
